import {useLayoutEffect, useRef, useState} from 'react';

// determine if an element's content is ellipsized (i.e., overflowing its container)
export const useIsEllipsized = (enabled = false) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isEllipsized, setIsEllipsized] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || !enabled) {
      return;
    }

    const check = () => {
      // check vertical clamp and horizontal overflow
      setIsEllipsized(el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight);
    };

    check();

    const ro = new ResizeObserver(check);
    ro.observe(el);

    return () => ro.disconnect();
  }, [enabled]);

  return {ref, isEllipsized};
};
